import {
  Button,
  Typography,
  IconButton,
  InputAdornment,
  TextField,
  Box,
  Grid,
  Dialog,
  Select,
  MenuItem,
  Radio,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";
import { actions, reducer, sliceKey } from "../../../redux/slice";
import { usePropertySaga } from "../../../redux/saga";
import { style } from "@mui/system";
import useStyles from "./styles";
import OtpInput from "react-otp-input";

type Props = {};
const Register = ({ showPopup, closePopup, handleClose = () => {} }) => {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: usePropertySaga });
  const styles = useStyles();
  const [show, setShow] = useState(false);
  const [reportType, setReportType] = useState<any>(null);
  const [selectedProperties, setSelectedProperties] = useState([]);
  const [timeRange, setTimeRane] = useState("");
  const [error, setError] = useState(false);
  const [otp, setOtp] = useState("");
  const [disable, setDisable] = useState(true);

  const close = () => {
    setShow(false);
    closePopup();
  };

  useEffect(() => {
    if (otp?.length === 4) {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, [otp?.length]);

  useEffect(() => {
    setShow(showPopup);
  }, [showPopup]);

  const handleReportTypeChange = (event) => {
    const option = event.target.value;
    setReportType(option);
  };

  const handleChange = (otp) => {
    setOtp(otp);
  };

  return (
    <Dialog open={show} className={styles.popup}>
      <Box sx={{ display: "flex", flexDirection: "column", margin: "16px" }}>
        <div
          style={{
            fontFamily: "Open Sans",
            fontSize: 18,
            color: "#192342",
            fontWeight: "400",
            textAlign: "center",
          }}
        >
          You have been removed from this property by the Landlord.Please
          register with your new residence address
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: 25,
          }}
        >
          <Button
            className={styles.outlinebtn}
            onClick={close}
            style={{ marginLeft: 0 }}
            variant="outlined"
          >
            Register
          </Button>
          <Button
            className={styles.signInButton}
            onClick={handleChange}
          >
            Cancel
          </Button>
        </div>
      </Box>
    </Dialog>
  );
};

export default Register;
